import { render, staticRenderFns } from "./DamageReportList.vue?vue&type=template&id=344ad28c&"
import script from "./DamageReportList.vue?vue&type=script&lang=js&"
export * from "./DamageReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports